import React, {PureComponent} from "react";
import Banner from "./Banner";
import BannerBottomSteps from "./BannerBottomSteps";
import CheckoutMain from "./CheckoutMain";
import AnyQuestions from "../../reusable/AnyQuestions";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import {PulseLoader} from "react-spinners";
import Validator from "validator";
import {withRouter, Router} from "react-router-dom";
import RechargeCheckout from '../rechargeCheckout';
import ESimCheckout from '../eSimCheckout';
import {addToCart, getCart, clearCart} from "../../modules/actions/cartActions";
import {
    placeOrder,
    placePaypalOrder,
    clearOrderResult,
    validateDiscount
} from "../../modules/actions/orderActions";
import NotificationAlert from "react-notification-alert";
import {
    geCurrentUser,
    updateShipping,
    updateBilling
} from "../../modules/actions/authActions";
import {addFlashMessage} from "../../modules/actions/flashMessages.js";
import qs from "qs";
import ConfirmOrder from "../rechargeCheckout/CheckoutMain";

const uuidv4 = require("uuid/v4");

function validateAddress(data) {
    let errors = {};
    if (Validator.isEmpty(data.firstname)) {
        errors.firstname = "This field is required";
    }

    if (Validator.isEmpty(data.lastname)) {
        errors.lastname = "This field is required";
    }

    if (Validator.isEmpty(data.address1)) {
        errors.address1 = "This field is required";
    }

    if (Validator.isEmpty(data.city)) {
        errors.city = "This field is required";
    }
    if (Validator.isEmpty(data.state)) {
        errors.state = "This field is required";
    }
    if (Validator.isEmpty(data.country)) {
        errors.country = "This field is required";
    }
    if (Validator.isEmpty(data.zipcode)) {
        errors.zipcode = "This field is required";
    }
    return {
        errors,
        isValid: isEmpty(errors)
    };
}

class Checkout extends PureComponent {

    step = 0;
    referenceStep = 0;

    recaptchaRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            step1: true,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
            billing: {
                firstname: "",
                lastname: "",
                address1: "",
                address2: "",
                country: "US",
                city: "",
                state: "",
                zipcode: ""
            },
            shipping: {
                firstname: "",
                lastname: "",
                address1: "",
                address2: "",
                country: "US",
                city: "",
                state: "",
                zipcode: ""
            },
            apply_discount: {},
            validate_discount_error : null,
            payment: {},
            easyReturn: true,
            paymentmode: "direct",
            orderPayload: {},
            tax: 0,
            errors: {},
            isLoading: false,
            isProcessing: false,
            isHuman: false,
            humanKey: null
        };

        console.log("contructorProps", this.props);

    }

    isValidAddress(address) {
        const {errors, isValid} = validateAddress(address);
        if (!isValid) {
            this.setState({errors});
        }
        return isValid;
    }

    componentDidMount() {

        let payload = {
            sessionId: localStorage.getItem("sessionId")
        };


        if (typeof this.props.location !== "undefined" && typeof this.props.location.params !== "undefined"
            && typeof this.props.location.params.cart !== "undefined") {
            this.performCartAction(this.props.location.params.cart);
            this.props.cart.cart = {...this.props.location.params.cart};

            this.setState({
                checkoutType: this.props.cart.cart.cartType
            });
        }

        this.props.getCart(payload);

        this.props.geCurrentUser();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log("previousProps", prevProps);
    }

    performCartAction(payload) {
        const {auth} = this.props;
        if (auth.isAuthenticated) {
            this.props
                .addToCart(payload)
                .then(data => {
                    const discount = this.props.location.params.discount;
                    if(discount) {
                        let cart = data.data;
                        this.props.cart.cart = cart;
                        this.validateDiscount(discount);
                    }
                    if (!data.status) {
                        this.showMessage(data.message);
                    }
                })
                .catch(error => {
                    this.showMessage(error.response.data.message);
                });
        }
    }

    getQueryParams() {
        const qsParsed = qs.parse(
            this.context.router.history.location.search.slice(1)
        );
        return !!qsParsed.login;
    }

    refetch = () => {
        let payload = {
            sessionId: localStorage.getItem("sessionId")
        };
        this.props.getCart(payload);
        this.props.geCurrentUser();
    };

    handleShipping = shipping => {
        this.props.updateShipping(shipping).then(data => {
            if (data.status) {
                this.setState({shipping});
                this.onStep2();
                this.props.geCurrentUser();
            }
        });
        this.onStep2();
    };
    handleBilling = billing => {
        billing.cartId = this.props.cart.cart;
        this.props.updateBilling(billing).then(data => {
            if (data.status) {
                this.setState({billing});
                this.onStep3();
            }
        });
    };

    calculateTax = () => {
        let tax = 0;
        //if (this.state.billing.state === "NJ") {
        if (this.state.shipping.state === "NJ") {
            if(typeof this.state.apply_discount.flatTotal !== "undefined" && this.state.apply_discount.flatTotal !== null && typeof this.state.apply_discount.flatTotal.grandTotal !== "undefined") {
                tax = (this.state.apply_discount.flatTotal.grandTotal / 100) * 6.625;
            }
            else {
                tax = (this.props.cart.cart.subtotal / 100) * 6.625;
            }
        }
        return tax.toFixed(2);
    };

    handleShippingMethod = () => {
        this.onStep4();
    };

    componentWillReceiveProps(nextProps) {
        console.log("nextProps",nextProps)
        if (nextProps.order.order.orderId) {
            console.log("coreCheckout OrderId", nextProps.order.order.orderId);
            console.log("calling in recieve props", nextProps.order.order);
            this.setState({orderPayload: nextProps.order.order});
            localStorage.setItem("sessionId", uuidv4());
            this.props.clearCart();
            this.props.clearOrderResult();
            if (nextProps.order.redirectUrl) {
                console.log("nextProps", nextProps.order.redirectUrl);
                window.location.href = nextProps.order.redirectUrl;
                return false;
            }

            this.onStep5();
        }

        /*if (isEmpty(nextProps.cart.cart)) {
            this.context.router.history.push("/");
        }*/

        if (this.state.checkoutType !== 'recharge' && nextProps.auth.profile.userShipping) {
            this.setState({shipping: nextProps.auth.profile.userShipping});
        }

        if (this.state.checkoutType !== 'recharge' && nextProps.cart.cart.billing) {
            this.setState({
                billing: nextProps.cart.cart.billing
            });
        }
    }

    isAddressFilled = () => {
        console.log("called", this.state.shipping);
        if (!this.isValidAddress(this.state.shipping)) {
            console.log("errors", this.state.errors);
            this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                        <div>
                            <b>Please Enter your shipping info</b>
                        </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
            });
            this.onStep1();
            return false;
        }

        if (!this.isValidAddress(this.state.billing)) {
            this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                        <div>
                            <b>Please Enter your Billing info</b>
                        </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
            });
            this.onStep2();
            return false;
        }
        return true;
    };

    handlePaypalPayment = paypal => {
        if(!this.state.isProcessing) {
            this.state.isProcessing = false;
            const orderPayload = {
                billing: this.state.billing,
                paypal: paypal,
                phone_no: (typeof this.props.cart.cart.phone_no !== "undefined") ? this.props.cart.cart.phone_no : "",
                cart: this.props.cart.cart,
                easyReturn: this.state.easyReturn,
                paymentmode: "paypal"
            };
            this.props
                .placePaypalOrder(orderPayload)
                .then(data => {
                    this.state.isProcessing = false;
                })
                .catch(error => {
                    this.refs.notify.notificationAlert({
                        place: "tc",
                        message: (
                            <div>
                                <div>
                                    <b>{error.response.data.message}</b>
                                </div>
                            </div>
                        ),
                        type: "danger",
                        icon: "now-ui-icons ui-1_bell-53",
                        autoDismiss: 7
                    });
                    this.state.isProcessing = false;
                });
        }
    };

    validateDiscount = discount_code => {
        let payload = {
            discount_code: discount_code,
            cart: this.props.cart.cart
        };
        console.log("discountPayload", payload)
        this.props.validateDiscount(payload).then(
            res => {
                // this.props.addToCart(
                //     {
                //         sessionId: localStorage.getItem("sessionId"),
                //         ...this.props.cart.cart,
                //         apply_discount : {
                //             type : res.apply_discount.type,
                //             value : res.apply_discount.value,
                //             products : (Array.isArray(res.apply_discount.products)) ? res.apply_discount.products : null
                //         }
                //
                //     }
                // );
                this.setState({
                    apply_discount: {...res.apply_discount},
                    validate_discount_error : false
                })
            },
            err => {
                this.setState({
                    validate_discount_error : true
                })
            }
        )
    }

    setDiscountCode = e => {
        this.setState({
            discount_code: e.target.value
        })
    }

    handlePayment = payment => {
        if(!this.state.isProcessing) {
            this.state.isProcessing = true;
            if (this.isAddressFilled()) {
                this.setState({payment, errors: {}, isLoading: true});
                const orderPayload = {
                    billing: this.state.billing,
                    payment: payment,
                    phone_no: (typeof this.props.cart.cart.phone_no !== "undefined") ? this.props.cart.cart.phone_no : "",
                    cart: this.props.cart.cart,
                    easyReturn: this.state.easyReturn,
                    paymentmode: this.state.paymentmode,
                    after_discount_totals_flat: (typeof this.state.apply_discount.flatTotal !== "undefined" && this.state.apply_discount.flatTotal !== null && typeof this.state.apply_discount.flatTotal.grandTotal !== "undefined") ? this.state.apply_discount.flatTotal : null,
                    after_discount_totals: (typeof this.state.apply_discount.totals !== "undefined" && this.state.apply_discount.totals !== null && this.state.apply_discount.totals.length > 0) ? this.state.apply_discount.totals : null,
                    humanKey: this.state.humanKey
                };

                this.props
                    .placeOrder(orderPayload)
                    .then(data => {
                        this.state.isProcessing = false;
                        this.setState({isLoading: false});
                    })
                    .catch(error => {
                        this.refs.notify.notificationAlert({
                            place: "bl",
                            message: (
                                <div>
                                    <div>
                                        <b>{error.response ? error.response.data.message : 'An error occurred on the server. Please try again.'}</b>
                                    </div>
                                </div>
                            ),
                            type: "danger",
                            icon: "now-ui-icons ui-1_bell-53",
                            autoDismiss: 7
                        });
                        this.state.isProcessing = false;
                        this.setState({isLoading: false});

                        this.recaptchaRef.current.reset();
                        this.setState({isHuman: false, humanKey: null});
                    });
            } else {
                this.state.isProcessing = false;
            }
        }
    };

    setpaymentMode = mode => {
        this.setState({
            paymentmode: mode
        });
    };

    onStepStart = () => {
        this.refetch();
        this.setState({
            step1: false,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
            isProcessing: false
        });
        this.context.router.history.goBack()
    };

    onStep1 = () => {
        this.refetch();
        this.setState({
            step1: true,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
            isProcessing: false
        });
        this.step = 1;
    };

    onStep2 = () => {
        this.refetch();
        this.setState({
            step1: false,
            step2: true,
            step3: false,
            step4: false,
            step5: false,
            isProcessing: false
        });
        this.step = 2;
    };

    onStep3 = () => {
        this.refetch();
        this.setState({
            step1: false,
            step2: false,
            step3: true,
            step4: false,
            step5: false,
            isProcessing: false
        });
        this.step = 3;
    };
    onStep4 = () => {
        this.refetch();
        this.setState({
            step1: false,
            step2: false,
            step3: false,
            step4: true,
            step5: false,
            isProcessing: false
        });
        this.step = 4;
    };

    onStep5 = () => {
        this.setState({
            step1: false,
            step2: false,
            step3: false,
            step4: false,
            step5: true,
            isProcessing: false
        });
        this.step = 5;
    };

    breadcrumbActive = (step) => {
        if (this.step > this.referenceStep) {
            this.referenceStep = this.step;
        }
        /*console.log("referenceStep: ", this.referenceStep);
        console.log("requestedStep: ", step);
        console.log("completedStep: ", this.step);*/
        if (this.referenceStep != 5 && (step < this.step || step <= this.referenceStep)) {
            switch (step) {
                case 1:
                    this.onStep1();
                    break;
                case 2:
                    this.onStep2();
                    break;
                case 3:
                    this.onStep3();
                    break;
                case 4:
                    this.onStep4();
                    break;
                case 5:
                    this.onStep5();
                    break;
            }
        }
    };

    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };

    // ReCAPTCHA Client Side
    verifyCaptcha = (res) => {
        if(res) {
            this.setState({ isHuman: true, humanKey: res })
        }
    }

    // ReCAPTCHA Expired
    expireCaptcha = () => {
        this.setState({ isHuman: false, humanKey: null })
    }

    render() {
        let cartType = this.props.cart.cart.cartType;
        if (typeof this.state.orderPayload !== "undefined" && this.state.orderPayload.total) {
            cartType = this.state.orderPayload.cart.cartType;
        }
        return (

            <div>

                {
                    (cartType === 'recharge' || cartType === 'device_recharge') ? (
                        <div>
                            <RechargeCheckout apply_discount={this.state.apply_discount}
                                              setDiscountCode={this.setDiscountCode} placeOrder={this.props.placeOrder}
                                              props={this.props} state={this.state}
                                              validateDiscount={this.validateDiscount}
                                              validate_discount_error={this.state.validate_discount_error}
                            />
                        </div>
                    ) : (
                        (cartType === 'esim') ? (
                            <div>
                                <ESimCheckout apply_discount={this.state.apply_discount}
                                                  setDiscountCode={this.setDiscountCode} placeOrder={this.props.placeOrder}
                                                  props={this.props} state={this.state}
                                                  validateDiscount={this.validateDiscount}
                                                  validate_discount_error={this.state.validate_discount_error}
                                />
                            </div>
                        ) : (
                        <div>
                            <PulseLoader
                                className="sweet-loading"
                                sizeUnit={"px"}
                                size={20}
                                color={"#123abc"}
                                loading={this.state.isLoading}
                            />
                            <NotificationAlert ref="notify"/>
                            <Banner status={this.state}/>
                            <BannerBottomSteps
                                status={this.state}
                                step1={this.onStep1}
                                step2={this.onStep2}
                                step3={this.onStep3}
                                step4={this.onStep4}
                                breadcrumbActive={this.breadcrumbActive}
                            />
                            <CheckoutMain
                                data={this.state}
                                router={this.props.location.params}
                                product={{...this.props.cart.cart.product}}
                                cart={this.props.cart.cart}
                                backStep1={this.onStepStart}
                                backStep2={this.onStep1}
                                backStep3={this.onStep2}
                                backStep4={this.onStep3}
                                apply_discount={this.state.apply_discount}
                                handleBilling={this.handleBilling}
                                handleShipping={this.handleShipping}
                                handleShippingMethod={this.handleShippingMethod}
                                handlePayment={this.handlePayment}
                                handlePaypalPayment={this.handlePaypalPayment}
                                orderPayload={this.state.orderPayload}
                                setpaymentMode={this.setpaymentMode}
                                calculateTax={this.calculateTax}
                                isAddressFilled={this.isAddressFilled}
                                isProcessing={this.state.isProcessing}
                                auth={this.props.auth}
                                validateDiscount={this.validateDiscount}
                                setDiscountCode={this.setDiscountCode}
                                validate_discount_error={this.state.validate_discount_error}
                                recaptchaRef={this.recaptchaRef}
                                isHuman={this.state.isHuman}
                                humanKey={this.state.humanKey}
                                verifyCaptcha={this.verifyCaptcha}
                                expireCaptcha={this.expireCaptcha}
                            />
                            <AnyQuestions/>
                            <StayTouch/>
                        </div>
                        )
                    )
                }

                {/*{this.state.step5 ? (*/}
                {/*<ConfirmOrder product={{...this.props.product}} orderPayload={this.props.orderPayload} />*/}
                {/*) : null}*/}

            </div>
        );
    }
}

Checkout.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart,
        order: state.order,
        redirectUrl: state.order.redirectUrl
    };
}

export default withRouter(connect(
    mapStateToProps,
    {
        addToCart,
        getCart,
        addFlashMessage,
        geCurrentUser,
        placeOrder,
        updateShipping,
        updateBilling,
        placePaypalOrder,
        clearCart,
        clearOrderResult,
        validateDiscount
    }
)(layoutWrapper(Checkout)));



// WEBPACK FOOTER //
// ./src/pages/checkout/index.js